import { useEffect } from "react";
import { useFormik } from "formik";
import { toast } from "react-toastify";

import Modal, { ModalProps } from "react-bootstrap/Modal";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { BsUpload } from "react-icons/bs";

import { TrackList } from "@/@types/app/TrackList";
import { TrackListFormData, updateTrackListImage } from "@/services/app/trackListService";

import { CardDropzone } from "@/components/CardDropzone";

type Props = ModalProps & {
	trackList: TrackList;
	onSuccess?: () => Promise<void>;
};

export function ModalTrackListImageEdit({ trackList, onSuccess, ...rest }: Props) {
	const initialValues = {} as TrackListFormData;
	const formik = useFormik<TrackListFormData>({
		initialValues,
		onSubmit: handleUpdateTrackListImage,
	});

	async function handleUpdateTrackListImage() {
		if (!formik.values.thumbnailFile || !trackList.id) return;
		const isUpdated = await updateTrackListImage(trackList.id, formik.values);
		if (isUpdated) {
			toast.success("Arquivos atualizados com sucesso");
			onSuccess && onSuccess();
		} else {
			toast.error("Erro ao registrar arquivo");
		}
	}

	useEffect(() => {
		if (trackList) {
			formik.setValues({
				description: trackList.description,
				title: trackList.title,
			} as TrackListFormData);
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [trackList]);

	return (
		<Modal size="lg" scrollable {...rest}>
			<Modal.Header closeButton>
				<Modal.Title>Edição de capa de playlist</Modal.Title>
			</Modal.Header>
			<Modal.Body>
				<Form onSubmit={formik.handleSubmit} encType="multipart/form-data">
					<Row className="my-3">
						<h5>Título: {trackList.title}</h5>
						<h5>Descrição: {trackList.description}</h5>
					</Row>
					<Row>
						<Col classname="mb-6">
							<Form.Group className="text-center bg-white">
								<Form.Label className="fs-5">
									<strong>Thumbnail</strong>
								</Form.Label>
								<CardDropzone
									inputName="thumbnailFile"
									description="Solte o arquivo aqui, para fazer o upload."
									acceptedFileType={{ "image/*": [".jpeg", ".png"] }}
									descriptionAcceptedFilesExtension="Upload somente de arquivo .jpg/.png (tamanho máximo: 10MB)"
									handleChange={(file: File) =>
										formik.setFieldValue("thumbnailFile", file)
									}
								/>
								{trackList.urlThumbnail && !formik.values.thumbnailFile && (
									<div>
										<img height="100px" src={trackList.urlThumbnail} alt="" />
									</div>
								)}
							</Form.Group>
						</Col>
					</Row>
					<Row>
						<div className="d-flex my-3 justify-content-center w-100">
							<Button
								className="ml-auto"
								type="submit"
								disabled={!formik.values.thumbnailFile}
							>
								<BsUpload className="me-2" /> Upload
							</Button>
						</div>
					</Row>
				</Form>
			</Modal.Body>
		</Modal>
	);
}
